require('./vision');
require('./score');

!(function () {
  const popup = document.querySelectorAll('.js-popup')
  const popupAndroid = document.querySelectorAll('.js-popup-android')
  const popupClose = document.querySelectorAll('.js-popupClose')
  const modal = document.getElementById('js-modal')
  const modal2 = document.getElementById('js-modal2')
  const showModalButtons = document.querySelectorAll('.js-show-modal')
  const hideModalButtons = document.querySelectorAll('.js-hide-modal')

  const showPopup = () => {
    popup.forEach(element => {
      element.removeAttribute('hidden')
    })
  }
  const showPopupAndroid = () => {
    popupAndroid.forEach(element => {
      element.removeAttribute('hidden')
      let deferredPrompt;
      const popupAndroidPwa = document.querySelector('.js-popup-android')
      // popupAndroidPwa.style.display = 'none';
      window.addEventListener('beforeinstallprompt', (e) => {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault();
        // Stash the event so it can be triggered later.
        deferredPrompt = e;
        // Update UI to notify the user they can add to home screen
        // popupAndroidPwa.style.display = 'block';
        popupAndroidPwa.addEventListener('click', (e) => {
          // hide our user interface that shows our A2HS button
          // popupAndroidPwa.style.display = 'none';
          // Show the prompt
          deferredPrompt.prompt();
          // Wait for the user to respond to the prompt
          deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
              console.log('User accepted the A2HS prompt');
            } else {
              console.log('User dismissed the A2HS prompt');
            }
            deferredPrompt = null;
          });
        });
      });
    })
  }

  /**
   * POPUP
   */
  popupClose.forEach(element => {
    element.addEventListener('click', () => {
      const parent = element.parentElement
      parent.setAttribute('hidden', 'hidden')
    })
  });

  /**
   * MODAL
   */
  if( modal ) {
    // オーバーレイをクリックでモーダルを閉じる
    modal.addEventListener('click', e => {
      modal.setAttribute('hidden', 'hidden')
    })
    if(hideModalButtons) {
      hideModalButtons.forEach( element => {
        element.addEventListener('click', () => {
          modal.setAttribute('hidden', 'hidden')
        })
      })
    }


    modal.querySelectorAll('.js-modal-content').forEach( element => {
      element.addEventListener('click', e => {
        document.body.classList.remove('is-modal-open')
        e.stopPropagation()
      })
    })

    showModalButtons.forEach( element => {
      element.addEventListener('click', () => {
        document.body.classList.add('is-modal-open')
        modal.removeAttribute('hidden')
      })
    })
  }

  if( modal2 ) {
    // オーバーレイをクリックでモーダルを閉じる
    modal2.addEventListener('click', e => {
      modal2.setAttribute('hidden', 'hidden')
    })
    if (hideModalButtons) {
      hideModalButtons.forEach(element => {
        element.addEventListener('click', () => {
          modal2.setAttribute('hidden', 'hidden')
        })
      })
    }
  }



  /**
   * PC / SP で処理を出し分ける
   */
  if ((navigator.userAgent.indexOf('iPhone') > 0 && navigator.userAgent.indexOf('iPad') == -1) || navigator.userAgent.indexOf('iPod') > 0) {
    document.body.classList.add('is-sp')
    if (window.matchMedia('(display-mode: standalone)').matches) {
      // ここにPWA環境下でのみ実行するコードを記述
    } else {
      showPopup()
    }
  } else if(navigator.userAgent.indexOf('Android') > 0) {
    document.body.classList.add('is-sp')
    if (window.matchMedia('(display-mode: standalone)').matches) {
      // ここにPWA環境下でのみ実行するコードを記述
    } else {
      showPopupAndroid()
    }
  } else {
    document.body.classList.add('is-pc')
  }


  const input = document.querySelector('#upload_photo');
  const button = document.querySelector('#upload_button')
  const figure = document.querySelector('#figure')
  const figureImage = document.querySelector('#figureImage')

  if(input) {
    input.addEventListener('change', (event) => { // <1>
      const [file] = event.target.files

      if (file) {
        figureImage.setAttribute('src', URL.createObjectURL(file))
        figure.style.display = 'block'
        button.style.display = 'none'
      } else {
        figure.style.display = 'none'
      }
    })
  }
  if($(".p-form-box-num-age").length > 0) {
    $(".p-form-box-num-age").click(function (){
      let text = $(".p-form-register-old-title-num").text();
      if(text === '') {
        if($(this).data('age') !== '0') {
          text = $(this).data('age');
          $(".p-form-register-old-title-num").text(text);
        }
      } else if(text.length > 1){
      } else {
        text = String(text)  + String($(this).data('age'));
        $(".p-form-register-old-title-num").text(text);
        $("#age").val(text);
        doSubmit();
      }
    });
    $(".p-form-box-num-back").click(function (){
      let text = $(".p-form-register-old-title-num").text();
      if(text.length > 1) {
        text = text.slice( 0, -1 );
      } else if(text.length > 0) {
        text = '';
      }
      $(".p-form-register-old-title-num").text(text);
      $("#age").val('');
    });
    $(".p-form-box-num-gender").click(function (){
      $(".p-form-box-num-gender").removeClass("on");
      $(this).addClass("on");
      $("#gender").val($(this).data("gender"));
      doSubmit();
    });
    function doSubmit() {
      if($("#age").val() !== '' && $("#gender").val() !== '') {
        $('#formRegister').submit();
      }
    }
  }
})();
